<template>
  <div class="h-carousel-item" >
    <div class="h-carousel-item__container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HCarouselItem',
  };
</script>



// WEBPACK FOOTER //
// package/carousel/src/item.vue